export default "__VITE_ASSET__DT8r3mJL__"